import {Component, inject} from '@angular/core';
import {filter} from 'rxjs';
import {SessionService} from '../../@core/session.service';
import { NavigationEnd, Router, RouterLink, RouterOutlet } from '@angular/router';
import {toSignal} from '@angular/core/rxjs-interop';
import {map} from 'rxjs/operators';
import { NzButtonComponent } from 'ng-zorro-antd/button';
import { NzTooltipDirective } from 'ng-zorro-antd/tooltip';
import { NzIconDirective } from 'ng-zorro-antd/icon';

@Component({
    selector: 'app-layout',
    templateUrl: './layout.component.html',
    styleUrls: ['./layout.component.scss'],
    imports: [NzButtonComponent, NzTooltipDirective, NzIconDirective, RouterLink, RouterOutlet]
})
export class LayoutComponent {

  private sess = inject(SessionService);
  router: Router = inject(Router);

  user = toSignal(this.sess.getUser$());
  url = toSignal(this.router.events.pipe(
    filter((event) => event instanceof NavigationEnd),
    map((e: any) => e.url)));

  async signOut(): Promise<void> {
    await this.sess.signOut();
  }
}
